var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-toggle-facet",
      class: {
        "rb-toggle-facet--disabled": _vm.disabled,
      },
      on: { click: _vm.onFacetClick },
    },
    [
      _c(
        "div",
        { staticClass: "rb-toggle-facet__top" },
        [
          _c("span", { staticClass: "rb-toggle-facet__label" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
          _vm._v(" "),
          _c(
            "rb-switch",
            _vm._b(
              {
                attrs: {
                  "aria-label": "toggle filter",
                  disabled: _vm.disabled,
                  "turn-on": _vm.active,
                },
                on: { toggle: _vm.toggleFacet },
              },
              "rb-switch",
              _vm._d({}, [_vm.dataMntName, _vm.dataMntValue])
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.description
        ? _c("span", { staticClass: "rb-toggle-facet__description" }, [
            _vm._v(_vm._s(_vm.description)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }